<div class="standard-toggle-switch-tristate-container">
    <div class="standard-toggle-switch">
        <div class="standard-toggle-switch-neutral-state" [ngbTooltip]="'standardToggleSwitchTristate.neutralStateTooltip' | translation | async" placement="auto" (click)="onChange(null)">
            {{ neutralToggledLabel }}
        </div>

        <div class="d-flex flex-row ps-3 pe-3">
            <div class="standard-toggle-switch-state-position" (click)="onChange(false)">{{ notToggledLabel }}</div>
            <div [class.standard-toggle-switch-not-active-state]="!background_blue" [class.standard-toggle-switch-active-state]="background_blue">
                <div>
                    <label class="btn-container">
                        <input #toggleUnselected type="radio" class="unselected" [checked]="checked === false" [name]="label" value="unselected" (blur)="onTouchedFn()" (click)="onChange(false)" />
                        <div class="checkmark"><i class="ion-checkmark-round"></i></div>
                    </label>
                    <label class="btn-container">
                        <input #toggleNeutral type="radio" class="neutral" [checked]="checked == null" [name]="label" value="neutral" (blur)="onTouchedFn()" (click)="onChange(null)" />
                        <div class="checkmark"><i class="ion-record"></i></div>
                    </label>
                    <label class="btn-container">
                        <input #toggleSelected type="radio" class="selected" [checked]="checked === true" [name]="label" value="selected" (blur)="onTouchedFn()" (click)="onChange(true)" />

                        <div class="checkmark"><i class="ion-close-round"></i></div>
                    </label>
                </div>
            </div>
            <div class="standard-toggle-switch-state-position" (click)="onChange(true)">{{ toggledLabel }}</div>
        </div>
    </div>
    <label class="standard-toggle-switch-caption">{{ label }}</label>
</div>
